import ReactTooltip from 'react-tooltip'
import { Info } from '@phosphor-icons/react'

import TextField from '../../../FormLegacy/FormFieldsV2/TextField'

const ConvenienenceFeeField = ({ handleChange, value, isError, onBlur }) => {
  const handleConvenienceFeeChange = (event) => {
    const nextValue = event.target.value

    // Allow clearing the field
    if (nextValue === '') {
      handleChange(event)
      return
    }

    // Allow only digits and optional decimal with up to 2 places
    if (!/^\d*\.?\d{0,2}$/.test(nextValue)) {
      return
    }

    const num = Number(nextValue)

    if (!Number.isNaN(num) && num > 100) {
      return
    }

    handleChange(event)
  }

  const handleConvenienceFeeBlur = (event) => {
    let value = event.target.value

    // Remove trailing decimal point
    if (value.endsWith('.')) {
      value = value.slice(0, -1)
    }

    // Clear if the value is exactly zero
    if (value !== '' && Number(value) === 0) {
      value = ''
    }

    if (value !== event.target.value) {
      handleChange({
        target: {
          name: event.target.name,
          value,
        },
      })
    }

    const isValid =
      value === '' || (/^\d+(\.\d{1,2})?$/.test(value) && Number(value) > 0 && Number(value) <= 100)

    onBlur?.(event, isValid)
  }

  return (
    <TextField
      name="residentConvenienceFeeRate"
      label={
        <div className="tooltip-label">
          Resident Convenience Fee % <Info size={20} data-tip data-for="convenience-id-tooltip" />
          <ReactTooltip
            className="tooltip"
            id="convenience-id-tooltip"
            multiline
            place="right"
            effect="solid"
          >
            <div style={{ maxWidth: '300px' }}>
              Sets the property's Resident Convenience Fee percentage. Applies to transactions in
              the modules toggled at right and appears to residents as a separate 'Convenience Fee'
              line item at checkout. Leave empty to disable; otherwise enter a value greater than 0,
              up to 100, with up to 2 decimal places
            </div>
          </ReactTooltip>
        </div>
      }
      placeholder=""
      //   onChange={handleChange}
      // onBlur={onBlur}
      onChange={handleConvenienceFeeChange}
      onBlur={handleConvenienceFeeBlur}
      value={value}
      isError={isError}
      //   type="number"
    />
  )
}

export default ConvenienenceFeeField
